module.exports = __webpack_public_path__ + "img/zach-pfp.8d55613f.png";